var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function setConsoleText(message, selector) {
    var consoleElement = document.querySelector(selector);
    if (consoleElement) {
        consoleElement.setAttribute('value', message); // Update text
    }
}
/**
 * Draws an image (texture) onto a canvas.
 *
 * @param canvasId The ID of the canvas element.
 * @param imageUrl The URL of the image to be drawn.
 */
export function drawTextureOnCanvas(canvas, context, imageUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var image;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!canvas) {
                        console.log('Canvas element not found');
                        throw new Error('Canvas element not found');
                    }
                    if (!context) {
                        console.log('Unable to get canvas context');
                        throw new Error('Unable to get canvas context');
                    }
                    // Load the image asynchronously
                    console.log("// Load the image asynchronously");
                    image = new Image();
                    image.crossOrigin = 'anonymous';
                    image.src = imageUrl;
                    console.log("imageUrl: ".concat(imageUrl));
                    console.log("// loading image");
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            image.onload = function () {
                                setTimeout(function () {
                                    resolve(true);
                                }, 100);
                            };
                            image.onerror = reject;
                        })];
                case 1:
                    _a.sent();
                    console.log("// draw image on canvas");
                    // Draw the image onto the canvas
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Removes a specified substring from a given string.
 *
 * @param originalString - The original string.
 * @param stringToRemove - The substring to remove.
 * @returns The modified string with the substring removed.
 */
export function removeSubstring(originalString, stringToRemove) {
    return originalString.replace(stringToRemove, '');
}
/**
 * Dispatches a custom event with a specified name and details.
 *
 * @param eventName The name of the custom event.
 * @param detail The data to be attached to the event's 'detail' property.
 */
export function raiseCustomEvent(eventName, detail, canvasLayer, opts) {
    // Create a custom event with the given name and detail
    var event = new CustomEvent(eventName, __assign({ detail: detail, bubbles: true }, (opts || {})));
    // Dispatch the event on the window object or another suitable target
    if (canvasLayer) {
        canvasLayer.dispatchEvent(event);
    }
    else {
        document.body.dispatchEvent(event);
    }
}
export var Utils = (function () {
    var DIGITS = 6;
    function numberToFixed(number) {
        return parseFloat(number.toFixed(DIGITS));
    }
    function loadJSON(filePath) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fetch(filePath)
                        .then(function (response) {
                        if (!response.ok) {
                            throw new Error("HTTP error! status: ".concat(response.status));
                        }
                        return response.json();
                    })];
            });
        });
    }
    function arrayNumbersToFixed(array) {
        for (var i = 0; i < array.length; i++) {
            array[i] = numberToFixed(array[i]);
        }
        return array;
    }
    function getTooltips(controllerName) {
        var tooltips;
        var tooltipName;
        switch (controllerName) {
            case 'windows-motion-samsung-controls': {
                tooltipName = '.windows-motion-samsung-tooltips';
                break;
            }
            case 'windows-motion-controls': {
                tooltipName = '.windows-motion-tooltips';
                break;
            }
            case 'oculus-touch-controls': {
                tooltipName = '.oculus-tooltips';
                break;
            }
            case 'vive-controls': {
                tooltipName = '.vive-tooltips';
                break;
            }
            default: {
                tooltipName = '.vive-tooltips';
                break;
            }
        }
        tooltips = Array.prototype.slice.call(document.querySelectorAll(tooltipName));
        return tooltips;
    }
    return {
        numberToFixed: numberToFixed,
        arrayNumbersToFixed: arrayNumbersToFixed,
        getTooltips: getTooltips,
        loadJSON: loadJSON
    };
}());
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
export function hsb2rgb(hsb) {
    var h = hsb[0], s = hsb[1], b = hsb[2];
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = b * (1 - s);
    var q = b * (1 - f * s);
    var t = b * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: return [b, t, p];
        case 1: return [q, b, p];
        case 2: return [p, b, t];
        case 3: return [p, q, b];
        case 4: return [t, p, b];
        case 5: return [b, p, q];
    }
}
function componentToHex(c) {
    var hex = Math.floor(c * 255).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
export function rgbToHex(rgb) {
    var _a = rgb.map(componentToHex), r = _a[0], g = _a[1], b = _a[2];
    return "#".concat(r).concat(g).concat(b);
}
export function rgb2hsv(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = (max === 0 ? 0 : d / max);
    var v = max;
    if (arguments.length === 1) {
        g = r.g;
        b = r.b;
        r = r.r;
    }
    switch (max) {
        case min:
            h = 0;
            break;
        case r:
            h = (g - b) + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = (b - r) + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = (r - g) + d * 4;
            h /= 6 * d;
            break;
    }
    return { h: h, s: s, v: v };
}
export function getRgbFromPosition(x, y, brightness) {
    if (brightness === void 0) { brightness = 1.0; }
    var toCenter = [x, y];
    var angle = Math.atan2(toCenter[1], toCenter[0]);
    var radius = Math.sqrt(toCenter[0] * toCenter[0] + toCenter[1] * toCenter[1]) * 2.0;
    var hue = (angle / Math.PI / 2) + 0.5;
    var rgb = hsb2rgb([hue, radius, brightness]);
    return rgbToHex(rgb);
}
export function limitToUnitCircle(x, y) {
    var distance = Math.sqrt(x * x + y * y);
    if (distance > 1) {
        // Normalize the vector if it's outside the unit circle
        return [x / distance, y / distance];
    }
    else {
        // Return the original coordinates if they're inside the unit circle
        return [x, y];
    }
}
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function rgbToHsv(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
export function hexToHsv(hex) {
    var rgb = hexToRgb(hex);
    if (rgb) {
        return rgbToHsv(rgb.r, rgb.g, rgb.b);
    }
}
export function uvToUnitCircle(u, v) {
    // Map UV coordinates (0 to 1) to Cartesian coordinates (-1 to 1)
    var x = 2 * u - 1;
    var y = 2 * v - 1;
    // Calculate the length of the vector
    var length = Math.sqrt(x * x + y * y);
    // Normalize the vector to put it on the edge of the unit circle if it's outside the circle
    return length <= 1 ? { x: x, y: y } : { x: x / length, y: y / length };
}
export function uvToColorHex(u, v, brightness) {
    // Convert UV to HSB
    var toCenter = { x: 0.5 - u, y: 0.5 - v };
    var angle = Math.atan2(toCenter.y, toCenter.x);
    var radius = Math.min(Math.sqrt(toCenter.x * toCenter.x + toCenter.y * toCenter.y) * 2, 1);
    var hue = (angle / (2 * Math.PI)) + 0.5;
    // HSB to RGB conversion
    var rgb = hsb2rgb2({ h: hue, s: radius, b: brightness });
    // RGB to Hex conversion
    return rgbToHex2(rgb.r, rgb.g, rgb.b);
}
// Helper function to convert HSB to RGB
function hsb2rgb2(hsb) {
    var h = hsb.h * 6;
    var s = hsb.s;
    var b = hsb.b;
    var i = Math.floor(h);
    var f = h - i;
    var p = b * (1 - s);
    var q = b * (1 - s * f);
    var t = b * (1 - s * (1 - f));
    var r = 0;
    var g = 0;
    var b_ = 0;
    switch (i % 6) {
        case 0:
            r = b;
            g = t;
            b_ = p;
            break;
        case 1:
            r = q;
            g = b;
            b_ = p;
            break;
        case 2:
            r = p;
            g = b;
            b_ = t;
            break;
        case 3:
            r = p;
            g = q;
            b_ = b;
            break;
        case 4:
            r = t;
            g = p;
            b_ = b;
            break;
        case 5:
            r = b;
            g = p;
            b_ = q;
            break;
    }
    return { r: r, g: g, b: b_ };
}
export function findGrayByPercentage(percentage) {
    // Ensure the percentage is between 0 and 1
    var validPercentage = Math.max(0, Math.min(1, percentage));
    // Interpolate between black (0) and white (255) based on the percentage
    var grayValue = Math.round(validPercentage * 255);
    // Convert the RGB values to a hex color string
    return rgbToHex3(grayValue, grayValue, grayValue);
}
function rgbToHex3(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
// Helper function to convert RGB to Hex
function rgbToHex2(r, g, b) {
    return "#" + ((1 << 24) + (Math.round(r * 255) << 16) + (Math.round(g * 255) << 8) + Math.round(b * 255)).toString(16).slice(1);
}
